
import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Contact from './components/pages/Contact';
import Brochure from './components/pages/Brochure';
import Footer from './components/inc/Footer';
import Gallerypage from './components/pages/Gallerypage';
import Project from './components/pages/Project';
import Exceldata from './components/pages/Exceldata';
import Aboutus from './components/pages/Aboutus';
import LandPage from './components/pages/LandPage';
import HappyPlotowner from './components/pages/HappyPlotowner';
import Blog from './components/pages/Blog';
import Plot from './components/pages/Plot';
import Riverside from './components/pages/Riverside';
import Aerocityphase2 from './components/pages/Aerocityphase2';
function App() {
  return (
   <Router>

      <div>



        <Routes>


          <Route axact path="/" element={<Home />} />
             <Route axact path="/contact-us" element={<Contact/>} />
               <Route axact path="/Brochure" element={<Brochure/>} />
                  <Route axact path="/gallery" element={<Gallerypage/>} />
                   <Route axact path="/Project" element={<Project/>} />
                    <Route axact path="/aboutus" element={<Aboutus/>} />
                       <Route axact path="/land-area" element={<LandPage/>} />
                        <Route axact path="/blog" element={<Blog/>} />
                                 <Route axact path="/Aerocityphase2" element={<Aerocityphase2/>} />
                         <Route axact path="/Riverside_Investment" element={<Riverside/>} />
                                         <Route axact path="/PlotsNear_KolkataAirport" element={<Plot/>} />
                             <Route axact path="/happy-plotowner" element={<HappyPlotowner/>} />
                     <Route axact path="/____excel_qurise" element={<Exceldata/>} />
      

     </Routes>
      <Footer/>

      </div>

    </Router>
  );
}

export default App;
